import {
  currentUserDisplayName,
  currentUserEmail,
  currentUserSub,
  decodeJwtPayload,
  loadTokens,
  performLogout,
} from "../auth";
import { formatCreditsBalance, maskUserSub } from "@vida/surf-core";
import { useSurfAccountSummary } from "../hooks/useSurfAccountSummary";

export function AccountPage() {
  const { credits, usage, balanceLabel, loading, error, refresh } = useSurfAccountSummary();
  const email = currentUserEmail();
  const name = currentUserDisplayName();
  const tokens = loadTokens();
  const issuer = tokens ? (decodeJwtPayload(tokens.id_token)?.iss as string | undefined) : undefined;

  return (
    <div className="surf-account-page">
      <h1>Account</h1>
      <dl className="surf-inspector-dl">
        <div>
          <dt>Nome</dt>
          <dd>{name}</dd>
        </div>
        <div>
          <dt>Email</dt>
          <dd>{email || "—"}</dd>
        </div>
        <div>
          <dt>Sub</dt>
          <dd title={currentUserSub()}>{maskUserSub(currentUserSub())}</dd>
        </div>
        {issuer && (
          <div>
            <dt>Issuer</dt>
            <dd className="surf-account-issuer">{issuer}</dd>
          </div>
        )}
        <div>
          <dt>Saldo crediti</dt>
          <dd>{loading ? "…" : balanceLabel}</dd>
        </div>
        {credits?.totalSpentCents != null && (
          <div>
            <dt>Totale speso (profilo)</dt>
            <dd>{formatCreditsBalance(credits.totalSpentCents)}</dd>
          </div>
        )}
      </dl>

      {error && <p className="error">{error}</p>}

      <button type="button" className="surf-btn" onClick={() => void refresh()}>
        Aggiorna crediti
      </button>

      {usage && usage.byFeature.length > 0 && (
        <section className="surf-usage-breakdown">
          <h2>Consumi ultimi {usage.days} giorni</h2>
          <p className="muted">
            Totale: {formatCreditsBalance(usage.totalSpendCents)}
          </p>
          <ul>
            {usage.byFeature.map((row) => (
              <li key={row.feature}>
                <span>{row.feature}</span>
                <span>{formatCreditsBalance(row.spendCents)}</span>
              </li>
            ))}
          </ul>
        </section>
      )}

      <button type="button" className="surf-btn surf-btn--danger" onClick={() => performLogout()}>
        Esci
      </button>
    </div>
  );
}
